<template>
  <div class="my_course">
    <ul class="pub_nav">
      <li class="active">
        <a href="javascript:;">我的课程</a>
      </li>
    </ul>

    <div class="pub_content">
      <div class="box">
        <div class="box_title">
          <div class="box_title_left">全部课程</div>
          <!-- <div class="box_title_right">
            <el-select v-model="paid">
              <el-option label="已付款" :value="true"></el-option>
              <el-option label="待付款" :value="false"></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="box_content">
          <!-- 表格数据 -->
          <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
import { format } from 'path';
export default {
  components: {
    myTable
  },
  data() {
    return {
      tableObj: {
        list: [
        ], //列表数据
        btns: [
          //按钮组
          {
            name: "删除",
            funcName: "deleteCourse"
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "",
            label: "视频信息",
            width: "500px",
            formatter: row => {
              return `<div class="video_info">
            <div class="video_left">
              <img src=${row.coverPath} alt />
            </div>
            <div class="video_right">
              <a href="#/school_design_detail?id=${row.id}">
                <p class="video_title">${row.name}</p>
              </a>
              <p class="video_time">${row.apply_create_date.split(" ")[0]}</p>
            </div>
          </div>`;
            }
          },
          {
            prop: "money",
            label: "价格",
            // width:"105px"

          },
          {
            prop: "apply_status_name",
            label: "状态"
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 0,
          pageSize: 8
        }
      },
      paid: true,
      course_list:[],  //课程列表
    };
  },
  created(){
    if (this.$store.state.info) {
      this.getList(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getList");
    }
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods: {
    // 按钮组
    btnClick(btn) {
      switch (btn.btnFuncName) {
        case "deleteCourse":
          this.$confirm('确定删除?', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            // 删除
            let obj = {
              id:btn.row.apply_id
            }
            this.api.deleteApply(obj)
            .then(res => {
              if(res.error.err_code != 0) return;
              this.$message({
                type: 'success',
                message: '删除成功！'
              });
              // 重新获取列表
              this.getList()
            })
          })
          .catch(() => {
            return
          });
          break;
      }
    },
    // 课程列表
    getList(){
      this.api.getApplyCollege({
        ...this.tableObj.layerpageinfo
      })
      .then(res => {
        if(res.error.err_code != 0) return;
        let list = res.obj.list;
        this.tableObj.list = list.length ? list : [];
        this.tableObj.layerpageinfo.total = res.obj.totalSize;   
      })
    },
    // 监听个人信息
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 改变页数
    changePage(pageNo) {
        this.tableObj.layerpageinfo.pageNo = pageNo.val;
        this.getList()
    },
  }
};
</script>


<style lang="scss">
.my_course {
  .box {
    // height: 535px;
    // padding: 0 30px 30px;
    .box_content {
      .el-table th {
        background-color: #f8f8f8;
      }
      .video_info {
        width: 480px;
        display: flex;
        // justify-content: space-between;
        .video_left {
          img {
            width: 128px;
            height: 72px;
          }
        }
        .video_right {
          display: flex;
          height: 72px;
          flex-direction: column;
          justify-content: space-between;
          padding: 5px 20px;
          box-sizing: border-box;
          .video_title {
            font-size: 14px;
            line-height: 24px;
            color: #333;
            max-width: 325px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            text-align: left;
          }
          .video_title:hover{
            color: #117EFF;
            cursor: pointer;
          }
          .video_time {
            font-size: 12px;
            color: #999;
            line-height: 22px;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>